
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import OrderService from '@/services/order.service';
import OrderDrawer from '@/views/carModule/order/components/OrderDrawer.vue';
import moment from 'moment';
import CarService from '@/services/car.service';


@Component({
  components: {
    OrderDrawer,
  },
})
export default class BRefundList extends Vue {
  @Ref('orderDrawer')
  orderDrawer!: OrderDrawer;

  @lazyInject(CarService)
  carService!: CarService;

  columns = [
    // {
    //   title: '退单号',
    //   dataIndex: 'order_nos',
    //   key: 'order_nos',
    //   align: 'center',
    //   width: 150,
    // },
    {
      title: '订单号',
      dataIndex: 'order_no',
      key: 'order_no',
      scopedSlots: { customRender: 'order_no' },
      align: 'center',
      width: 150,
    },
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: 100,
    },
    {
      title: '店铺名称',
      dataIndex: 'shopName',
      key: 'shopName',
      align: 'center',
      width: 160,
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: 130,
    },
    {
      title: '订单金额',
      dataIndex: 'pay_price',
      key: 'pay_price',
      align: 'center',
      width: 100,
    },
    {
      title: '支付时间',
      dataIndex: 'pay_time',
      key: 'pay_time',
      align: 'center',
      width: 160,
    },
    {
      title: '退款类型',
      dataIndex: 'refundType',
      key: 'refundType',
      align: 'center',
      width: 100,
    },
    {
      title: '退款金额',
      dataIndex: 'amount',
      key: 'amount',
      align: 'center',
      width: 100,
    },
    {
      title: '退款记录时间',
      dataIndex: 'refund_time',
      key: 'refund_time',
      align: 'center',
      width: 160,
    },
    {
      title: '退款记录人',
      dataIndex: 'refund_user',
      key: 'refund_user',
      align: 'center',
      width: 120,
    },
  ];

  dataSource = [];

  pay_time: any = [];

  refund_time: any = [];

  formData: any = {
    poi: '',
    shop_name: '',
    order_no: '',
    pay_time_start: '',
    pay_time_end: '',
    refund_type: 0,
    refund_time_start: '',
    refund_time_end: '',
  };

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
    onChange: this.onChange,
  };

  @lazyInject(OrderService)
  orderService!: OrderService;

  @Watch('$route')
  watchPagination() {
    const { pageNum, pageSize, poi, shop_name, order_no, pay_time_start, pay_time_end, refund_type, refund_time_start, refund_time_end } = this.$route.query;
    const queryParams: any = {
      page: pageNum || 1,
      pageSize: pageSize || 10,
    };
    if (poi) {
      queryParams.poi = poi;
      this.formData.poi = poi;
    }
    if (shop_name) {
      queryParams.shop_name = shop_name;
      this.formData.shop_name = shop_name;
    }
    if (order_no) {
      queryParams.order_no = order_no;
      this.formData.order_no = order_no;
    }
    if (pay_time_start) {
      queryParams.pay_time_start = `${pay_time_start} 00:00:00`;
      queryParams.pay_time_end = `${pay_time_end} 23:59:59`;
      this.formData.pay_time_start = pay_time_start;
      this.formData.pay_time_end = pay_time_end;
      this.pay_time = [moment(pay_time_start as string), moment(pay_time_end as string)];
    }
    if (refund_type) {
      queryParams.refund_type = +refund_type;
      this.formData.refund_type = +refund_type;
    }
    if (refund_time_start) {
      queryParams.refund_time_start = `${refund_time_start} 00:00:00`;
      this.formData.refund_time_start = refund_time_start;
      queryParams.refund_time_end = `${refund_time_end} 23:59:59`;
      this.formData.refund_time_end = refund_time_end;
      this.refund_time = [moment(refund_time_start as string), moment(refund_time_end as string)];
    }
    this.getList(queryParams);
  }

  /**
   * 时间选择器
   * @param time 时间
   */
  onChangePayTime(time: any) {
    this.pay_time = time;
    if (time.length > 0) {
      this.formData.pay_time_start = moment(time[0]).format('YYYY-MM-DD');
      this.formData.pay_time_end = moment(time[1]).format('YYYY-MM-DD');
    } else {
      this.formData.pay_time_start = '';
      this.formData.pay_time_end = '';
    }
  }

  onChangeRefundTime(time: any) {
    this.refund_time = time;
    if (time.length > 0) {
      this.formData.refund_time_start = moment(time[0]).format('YYYY-MM-DD');
      this.formData.refund_time_end = moment(time[1]).format('YYYY-MM-DD');
    } else {
      this.formData.refund_time_start = '';
      this.formData.refund_time_end = '';
    }
  }

  LookCOeder(order_no: string) {
    this.orderDrawer.init(order_no);
  }

  /**
   * 搜索
   */
  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }


  /**
   * 重置
   */
  reset() {
    this.pay_time = [];
    this.refund_time = [];
    this.formData = {
      poi: '',
      shop_name: '',
      order_no: '',
      pay_time_start: '',
      pay_time_end: '',
      refund_type: 0,
      refund_time_start: '',
      refund_time_end: '',
    };
    this.pagination.current = 1;
    const { pageSize } = this.pagination;
    const queryParams: any = {
      pageNum: 1,
      pageSize,
    };
    queryParams.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query: queryParams,
    });
  }

  /**
   * 分页切换
   * @param page 页码
   */
  onChange(page: number) {
    this.pagination.current = page;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.getQueryParams();
  }

  async getList(queryParams: any) {
    const res = await this.carService.getCarOrderRefundList(queryParams, this.$el);
    if (res) {
      this.dataSource = res.list;
      this.pagination.total = res.total;
    }
  }


  getQueryParams() {
    const { current, pageSize } = this.pagination;
    const { poi, shop_name, order_no, pay_time_start, pay_time_end, refund_type, refund_time_start, refund_time_end } = this.formData;
    const queryParams: any = {
      pageNum: current,
      pageSize,
    };
    if (poi) {
      queryParams.poi = poi;
    }
    if (shop_name) {
      queryParams.shop_name = shop_name;
    }
    if (order_no) {
      queryParams.order_no = order_no;
    }
    if (pay_time_start) {
      queryParams.pay_time_start = pay_time_start;
    }
    if (pay_time_end) {
      queryParams.pay_time_end = pay_time_end;
    }
    if (refund_type) {
      queryParams.refund_type = +refund_type;
    }
    if (refund_time_start) {
      queryParams.refund_time_start = refund_time_start;
    }
    if (refund_time_end) {
      queryParams.refund_time_end = refund_time_end;
    }
    queryParams.timestamp = `${Math.round(Date.now() / 1000)}`;
    this.$router.push({
      query: queryParams,
    });
  }

  mounted() {
    this.watchPagination();
  }
}

